export default {"src":"/_next/static/media/setting-fill.244840d2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};